import { useState, useEffect } from 'react';

const useMlbNative = () => {

    const [
        data,
        setData,
    ] = useState({});

    useEffect(() => {

        const onLoad = () => {

            if (mlbNative) {

                mlbNative.initialize(() => setData({ share: mlbNative.share }));

            }

        };

        window.addEventListener('mlbNativeLoaded', onLoad, {
            capture: true,
            once: true,
            passive: true,
        });

        return () => window.removeEventListener('mlbNativeLoaded', onLoad);

    }, []);

    return data;

};

export default useMlbNative;
